import { createRouter, createWebHistory } from 'vue-router'
import index from '@/components/chat.vue'

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            name: 'index',
            component: index
        },
        {
            path: '/mobile_chat',
            name: 'mobile_chat',
            component: () => import('@/components/mobile_chat.vue')
        },
        {
            path: '/wxlogin',
            name: 'wxlogin',
            component: () => import('@/components/wechat_login.vue')
        }
    ]
})

export default router